/* eslint-disable react/button-has-type */
/* eslint-disable @getify/proper-ternary/nested */
import {
  LinearProgress,
  Step,
  StepConnector,
  StepIconProps,
  StepLabel,
  Stepper,
  withStyles,
  Divider,
  Container,
} from '@material-ui/core';
import { DefectTypesMap } from 'app/consumer-app/views/report-fault/report-fault-utils';
import { productImg } from 'app/core/api/product-assignment/api-product-assignment.types';
import styled from 'styled-components/macro';
import { useEffect, useState } from 'react';
import { useUrlParams } from 'app/tools/hooks/misc-hooks';
import LoadingOverlay from 'app/shared/page-parts/LoadingOverlay';
import { useSetPageTitle } from 'app/shared/context-hooks/use-titlebar.hook';
import Icon from 'app/shared/components/icon/Icon';
import IconLib, {
  DocumentSvg,
  ExitSvg,
  LoginSvg,
  SettingSvg,
  SquareTick,
  DocumentTick,
} from 'app/shared/components/icon/icon-lib';
import {
  useQuoteSummery,
  useRepairerCase,
  useUpdateStatus,
  useRepaircasePaymentDetail,
} from 'app/core/api/repairer/api-repairer';
import {
  RepairStatusUpdate,
  Quote as RepairQuoteDetails,
  QuoteDetails,
} from 'app/core/api/repairer/api-repairer.types';
import { StatusTypeMap } from 'app/business-app/views/business-profile/status-type-util';
import { appEnv, AppVariant } from 'app/core/environment';
import Button from 'app/shared/components/button/Button';
import styledFuncs from 'app/styles/styledFuncs';
import { useShowInfo } from 'app/shared/context-hooks/use-show-info.hook';
import { getOtherUsersName } from 'app/core/api/user/user-utils';
import PaymentDetails from './payment-details';
import Rating from './rating';
import Body from '../../components/typography/body/Body';
import ProductPictureOrDefault from '../../components/app-image/ProductPictureOrDefault';
import ProductCommments from './product-comments';
import CreateQuote from './create-quote';

const imgHeight = 80;

const ProductPicture = styled(ProductPictureOrDefault)`
  width: 100px;
  padding: 0;
  justify-content: center;
  text-align: center;
  display: block;
`;

// const caseStatus = [
//   'customer_drop_off',
//   'under_diagnosis',
//   'repair_complete',
//   'ready_for_collection',
//   'collected',
//   'customer_confirmed',
// ];

// const steps = [
//   'Item Received',
//   'Under Diagnosis',
//   'Repair Complete',
//   'Ready For Collection',
//   'Collected',
//   'Customer Confirmed',
// ];

const DetailsTitle = styled(Body)`
  font-weight: 600;
  font-size: 15px;
  color: #31ad31;
  + * {
    margin: ${styledFuncs.pad(0.5)} ${styledFuncs.pad(1.5)} 0;
  }
`;

const DetailData = styled(Body)`
  font-weight: 500;
  font-size: 13px;
  color: #000000;
  + * {
    margin: ${styledFuncs.pad(0.5)} ${styledFuncs.pad(1.5)} 0;
  }
`;
// const CustomListItemTextName = styled(ListItemText)`
//   flex: 2 0;
//   overflow-wrap: break-word;
// `;
// const CustomListItemText = styled(ListItemText)`
//   flex: 1 1;
//   overflow-wrap: break-word;
// `;

// type Props = {
//   onTabChange?: (val: unknown) => unknown;
// };
export default function QuoteTrackingDrawer(): JSX.Element {
  const { id } = useUrlParams(['id']);
  const { resource: quoteSummery } = useQuoteSummery(id);
  const {
    resource: repairCase,
    request: loadAgain,
    loading,
  } = useRepairerCase(id);
  const [caseStatus, setCaseStatus] = useState<string[]>([]);
  const [steps, setSteps] = useState<string[]>([]);
  const [isRatingOpen, setIsRatingOpen] = useState<boolean>(false);
  // const {
  //   resource: repairerTransaction,
  //   request: loadTransactionDetail$,
  // } = useTransactionDetail();
  const {
    resource: repairerCasePaymentDetail,
    request: loadRepaircasePaymentDetail$,
  } = useRepaircasePaymentDetail();

  useEffect(() => {
    const repairStatus = [
      'repair_quote_issued',
      'repair_quote_accepted',
      'under_repair',
      'repair_completed',
      'ready_for_collection',
      'item_collected',
    ];
    if (repairStatus.find(m => m === repairCase?.caseStatus)) {
      setCaseStatus(repairStatus);

      setSteps([
        'Repair Quote Issued',
        'Repair Quote Accepted',
        'Under Repair',
        'Repair Completed',
        'Ready for  Collection',
        'Item Collected',
      ]);
    } else {
      setCaseStatus([
        'diagnosis_quote_issued',
        'diagnosis_quote_accepted',
        'item_received',
        'under_diagnosis',
        'diagnosis_completed',
        'ready_for_collection',
        'item_collected',
      ]);

      setSteps([
        'Diagnosis Quote Issued',
        'Diagnosis Quote Accepted',
        'Item Received',
        'Under Diagnosis',
        'Diagnosis Completed',
        'Ready for  Collection',
        'Item Collected',
      ]);
    }
  }, [repairCase]);

  const { request$: updateStatus, sending } = useUpdateStatus();
  /*
  const loadingRef = useWatchAsRef(loading);  
  const titleMsg = loadingMissing ? 'Loading...' : `Task Info`;
  useEffect(() => {
    if (!loadingRef.current) request();
  }, [loadingRef, request]);
  useSetPageTitle(titleMsg);
  */
  // useSetPageTitle(`Task Info`);
  const otherUserName =
    getOtherUsersName(repairCase) ||
    (appEnv.APP_VARIANT === AppVariant.CONSUMER ? 'Case' : 'Job');

  useSetPageTitle(`${otherUserName}`);
  const [activeStep, setActiveStep] = useState<number>(0);
  const [repairDetails, setRepairDetails] = useState(false);
  const [showDetailStatus, setShowDetailStatus] = useState(false);
  const [currentStatus, setCurrentStatus] = useState('');
  const [expandStatus, setExpandStatus] = useState(false);
  const { showDialog } = useShowInfo();

  const [isCommentDrawerOpen, SetIsCommentDrawerOpen] =
    useState<boolean>(false);
  const [quoteOpen, SetQuoteOpen] = useState<boolean>(false);
  const { productDefectDetails } = repairCase || {};
  const { assignedProductDetails } = productDefectDetails || {};
  const { productDetails } = assignedProductDetails || {};
  const issueType =
    DefectTypesMap.get(productDefectDetails?.title) ||
    productDefectDetails?.title;
  const isConsumer = appEnv.APP_VARIANT === AppVariant.CONSUMER;
  const loadRepairCaseApi = () => {
    loadAgain();
  };
  const SetIsQuoteOpen = () => {
    SetQuoteOpen(true);
    loadRepairCaseApi();
  };
  useEffect(() => {
    // loadTransactionDetail$(Number(id));
    loadRepaircasePaymentDetail$(Number(id));
    // const step =
    //   repairCase?.caseStatus === 'repair_complete'
    //     ? 2
    //     : repairCase?.caseStatus === 'under_repair'
    //     ? 1
    //     : 0;
    const step = repairCase?.caseStatus
      ? caseStatus.findIndex(
          element => element === repairCase?.caseStatus
        )
      : 0;

    setActiveStep(step);
    setCurrentStatus(repairCase?.caseStatus ?? 'accepted');

    if (
      repairCase?.caseStatus === 'diagnosis_completed' &&
      !repairCase?.diagnosisComment
    ) {
      SetIsCommentDrawerOpen(true);
    } else if (
      repairCase?.caseStatus === 'repair_completed' &&
      !repairCase?.repairerComments
    ) {
      SetIsCommentDrawerOpen(true);
    } else {
      SetIsCommentDrawerOpen(false);
    }

    const callUpdateStatusAPI = () => {
      const staus: RepairStatusUpdate = {
        repairCase: Number(id),
        status: 'item_collected',
      };
      updateStatus(staus).subscribe(() => loadAgain());
      setCurrentStatus('item_collected');
    };

    if (isConsumer) {
      if (repairCase?.caseStatus === 'ready_for_collection') {
        // if (repairCase?.caseStatus === 'consumer_item_collected') {
        showDialog({
          title: 'Confirm Item Collection',
          message: (
            <div>
              Are you sure that you want to confirm that the item has
              been collected?
              <p style={{ color: 'red' }}>
                {' '}
                Payment will be deducted
              </p>
            </div>
          ),
          onDismissed: () => {},
          actions: [
            { text: 'I confirm', callback: callUpdateStatusAPI },
            {
              text: 'Cancel',
            },
          ],
        });
      } else if (
        repairCase?.caseStatus === 'item_collected' &&
        !repairCase.ratingGiven
      ) {
        setIsRatingOpen(true);
      }
    }
  }, [
    loadAgain,
    caseStatus,
    id,
    loadRepaircasePaymentDetail$,
    repairCase,
    isConsumer,
    updateStatus,
    showDialog,
  ]);

  const updateStatusCall = (status: string) => {
    const currentStep = caseStatus.findIndex(
      element => element === status
    );
    let error = false;
    if (
      status === 'ready_for_collection' ||
      status === 'item_collected'
    ) {
      if (caseStatus.length === 7 && activeStep < 4) error = true;
      else if (activeStep < 3) error = true;
    }
    if (
      expandStatus &&
      (activeStep === 0 || activeStep < currentStep) &&
      status !== 'item_collected' &&
      !error
    ) {
      const staus: RepairStatusUpdate = {
        repairCase: Number(id),
        status,
      };
      updateStatus(staus).subscribe(() => loadAgain());

      setCurrentStatus(status);
    }
  };

  // const onClickChat = () => {
  //   if (onTabChange) {
  //     onTabChange(2);
  //   }
  // };
  // const Table = styled.table`
  //   width: 100%;
  //   border-collapse: separate;
  //   table-layout: fixed;
  //   text-align: center;
  //   tr {
  //     border: 1px solid #eaeaea;
  //   }
  //   th {
  //     color: #31ad31;
  //     font-size: 16px;
  //     font-weight: 500;
  //     text-align: left;
  //   }
  //   td {
  //     margin: 5px auto;
  //     text-align: right;
  //   }
  // `;

  // const updateStatusCall1 = (status: string) => {
  //   const callUpdateStatusAPI = () => {
  //     const staus: RepairStatusUpdate = {
  //       repairCase: Number(id),
  //       status,
  //     };
  //     updateStatus(staus).subscribe(() => loadAgain());
  //     setCurrentStatus(status);
  //   };
  //   if (
  //     status === 'item_collected' &&
  //     repairCase?.caseStatus === 'ready_for_collection'
  //   ) {
  //     showDialog({
  //       title: 'Confirm Item Collection',
  //       message: (
  //         <div>
  //           Are you sure that you want to confirm that the item has
  //           been collected?
  //           <p style={{ color: 'red' }}> Payment will be deducted</p>
  //         </div>
  //       ),
  //       onDismissed: () => {},
  //       actions: [
  //         { text: 'I confirm', callback: callUpdateStatusAPI },
  //         {
  //           text: 'Cancel',
  //         },
  //       ],
  //     });
  //   }
  // };
  // const onClickChat = () => {
  //   if (onTabChange) {
  //     onTabChange(2);
  //   }
  // };
  // const Table = styled.table`
  //   width: 100%;
  //   border-collapse: separate;
  //   table-layout: fixed;
  //   text-align: center;
  //   tr {
  //     border: 1px solid #eaeaea;
  //   }
  //   th {
  //     color: #31ad31;
  //     font-size: 16px;
  //     font-weight: 500;
  //     text-align: left;
  //   }
  //   td {
  //     margin: 5px auto;
  //     text-align: right;
  //   }
  // `;

  // const ColorlibConnector = withStyles({
  //   alternativeLabel: {
  //     top: 22,
  //   },
  //   active: {
  //     '& $line': {
  //       backgroundColor: '#6ABC35',
  //     },
  //   },
  //   completed: {
  //     '& $line': {
  //       backgroundColor: '#6ABC35',
  //     },
  //   },
  //   line: {
  //     height: 3,
  //     border: 0,
  //     backgroundColor: '#EAEAEA',
  //     borderRadius: 1,
  //   },
  // })(StepConnector);

  const ColorlibConnectorVertical = withStyles({
    alternativeLabel: {
      top: 22,
    },
    active: {
      '& $line': {
        backgroundColor: '#6ABC35',
      },
    },
    completed: {
      '& $line': {
        backgroundColor: '#6ABC35',
      },
    },
    line: {
      height: 3,
      border: 0,
      backgroundColor: '#EAEAEA',
      borderRadius: 1,
      width: '3px',
      margin: '-6px 12px',
    },
  })(StepConnector);

  const ColorlibStepIconRoot = styled('div')<{
    ownerState: { completed?: boolean; active?: boolean };
  }>(({ ownerState }) => ({
    backgroundColor: '#FFFFFF',
    zIndex: 1,
    color: '#000000',
    width: 50,
    height: 50,
    display: 'flex',
    borderRadius: '50%',
    justifyContent: 'center',
    alignItems: 'center',
    boxShadow: '0 4px 10px 0 rgba(0,0,0,.25)',
    svg: {
      path: { fill: '#000000' },
    },
    ...(ownerState.active && {
      border: '1px solid #6ABC35',
      svg: {
        path: { fill: '#6ABC35' },
      },
    }),
    ...(ownerState.completed && {
      border: '1px solid #6ABC35',
      svg: {
        path: { fill: '#6ABC35' },
      },
    }),
  }));

  function ColorlibStepIcon(props: StepIconProps) {
    const { active, completed, className } = props;

    // const icons: { [index: string]: React.ReactElement } = {
    //   1: <LoginSvg />,
    //   2: <DocumentSvg />,
    //   3: <DocumentSvg />,
    //   4: <InfoCircleSvg />,
    //   5: <DocumentSvg />,
    //   6: <DocumentSvg />,
    //   7: <DocumentSvg />,
    //   8: <DocumentSvg />,
    //   9: <ExitSvg />,
    //   10: <DocumentSvg />,
    //   11: <DocumentSvg />,
    // };
    const icons: { [index: string]: React.ReactElement } = {
      1: <DocumentSvg />,
      2: <DocumentTick />,
      3: <LoginSvg />,
      4: <SettingSvg />,
      5: <SquareTick />,
      6: <DocumentSvg />,
      7: <ExitSvg />,
      8: <DocumentSvg />,
      9: <ExitSvg />,
      10: <DocumentSvg />,
      11: <DocumentSvg />,
    };
    const { icon } = props;
    return (
      <ColorlibStepIconRoot
        ownerState={{ completed, active }}
        className={className}
      >
        {icons[String(icon)]}
      </ColorlibStepIconRoot>
    );
  }
  const BorderLinearProgress = withStyles(theme => ({
    root: {
      borderRadius: 5,
      width: 10,
      height: showDetailStatus
        ? `${
            // eslint-disable-next-line @getify/proper-ternary/nested
            repairCase?.caseTail
              ? repairCase?.caseTail?.length * 21
              : 0
          }px`
        : '60px',
      transform: 'rotate(180deg)',
    },
    colorPrimary: {
      backgroundColor:
        theme.palette.grey[
          theme.palette.type === 'light' ? 200 : 700
        ],
    },
    bar: {
      borderRadius: 5,
      transform: () =>
        `translateY(${
          currentStatus === 'customer_confirmed'
            ? '0'
            : showDetailStatus
            ? '5'
            : '40'
        }%) !important`,
      backgroundColor: theme.palette.primary.main,
    },
  }))(LinearProgress);

  const Table = styled.table`
    border-collapse: separate;
    table-layout: fixed;
    th {
      text-align: left;
      padding: ${styledFuncs.pad(0.5)} ${styledFuncs.pad(1.5)};
    }
    th:first-child {
      width: 50%;
    }
    th:nth-child(2) {
      text-align: center;
      width: 20%;
    }
    th:nth-child(3) {
      text-align: right;
      width: 30%;
    }
    tr {
      border-radius: 10px;
    }
    td {
      border-top: 1px solid #eaeaea;
      border-bottom: 1px solid #eaeaea;
      padding: ${styledFuncs.pad(0.5)} ${styledFuncs.pad(1.5)};
      color: #000;
    }
    td:first-child {
      border-left: 1px solid #eaeaea;
      width: 50%;
      border-radius: 10px 0 0 10px;
      overflow-wrap: break-word;
    }
    td:nth-child(2) {
      text-align: center;
      width: 20%;
      border-right: solid 1px #fff !important;
    }
    td:last-child {
      border-right: 1px solid #eaeaea;
      border-radius: 0 10px 10px 0;
      text-align: right;
      width: 30%;
    }
    tr:last-child td {
      color: #31ad31;
    }
    thead {
      font-weight: 600;
      display: table;
      table-layout: fixed;
      width: 100%;
    }
    tbody {
      display: table;
      table-layout: fixed;
      width: 100%;
      border-spacing: 0 10px;
    }
  `;

  // const steps = ['Customer Drop Off', 'Under Repair', 'Pick Up'];
  let quoteDetail = <></>;
  if (quoteSummery) {
    if (isConsumer) {
      quoteDetail = (
        <>
          <Container
            style={{
              background: '#FFFFFF',
              boxShadow: '0px 3px 10px rgba(0, 0, 0, 0.161)',
              borderRadius: '10px',
            }}
          >
            {/* <Stepper
            alternativeLabel
            activeStep={activeStep}
            connector={<ColorlibConnector />}
          >
            {steps.map(label => (
              <Step key={label}>
                <StepLabel
                  StepIconComponent={(e: StepIconProps) =>
                    ColorlibStepIcon(e)
                  }
                >
                  {label}
                </StepLabel>
              </Step>
            ))}
          </Stepper> */}
            <Stepper
              activeStep={activeStep}
              orientation="vertical"
              connector={<ColorlibConnectorVertical />}
              style={{ padding: '24px 0' }}
            >
              {steps.map((label, index) => (
                <Step
                  key={caseStatus[index]}
                  // onClick={() => updateStatusCall1(caseStatus[index])}
                  style={{
                    opacity:
                      activeStep >= index ||
                      activeStep === steps.length - 2
                        ? '1'
                        : '0.4',
                  }}
                >
                  <StepLabel
                    StepIconComponent={(e: StepIconProps) =>
                      ColorlibStepIcon(e)
                    }
                  >
                    {label}
                  </StepLabel>
                </Step>
              ))}
            </Stepper>

            {!quoteSummery?.isWithWarranty && (
              <>
                <div
                  style={{
                    flexGrow: 1,
                    // height: 300,
                    gap: 10,
                    // display: 'flex',
                    display: 'none',
                    padding: 10,
                  }}
                >
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      flexDirection: 'column',
                      flex: 2,
                      textAlign: 'right',
                      fontSize: '10px',
                    }}
                  >
                    {repairCase?.caseTail?.map((casetail, index) => (
                      <div
                        key={casetail.date}
                        style={
                          index === 0 ||
                          index ===
                            repairCase?.caseTail?.length - 1 ||
                          showDetailStatus === true
                            ? index !== 0 &&
                              index !==
                                repairCase?.caseTail?.length - 1
                              ? {
                                  color: '#A8A8A8',
                                  marginBottom: '5px',
                                }
                              : {}
                            : { display: 'none' }
                        }
                      >
                        <div>
                          {StatusTypeMap.get(casetail.status)}
                        </div>
                        {repairCase?.caseTail?.length > 2 &&
                          index === 0 && <br />}
                      </div>
                    ))}
                  </div>
                  <BorderLinearProgress
                    variant="determinate"
                    // eslint-disable-next-line @getify/proper-ternary/nested
                    value={currentStatus === 'collected' ? 0 : 10}
                    style={{ flex: 0.05 }}
                  />
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      flexDirection: 'column',
                      flex: 2,
                      textAlign: 'left',
                      fontSize: '10px',
                    }}
                  >
                    {repairCase?.caseTail?.map((casetail, index) => (
                      <div
                        key={casetail.date}
                        style={
                          index === 0 ||
                          index ===
                            repairCase?.caseTail?.length - 1 ||
                          showDetailStatus === true
                            ? // eslint-disable-next-line @getify/proper-ternary/nested
                              index !== 0 &&
                              index !==
                                repairCase?.caseTail?.length - 1
                              ? {
                                  color: '#A8A8A8',
                                  marginBottom: '5px',
                                }
                              : {}
                            : { display: 'none' }
                        }
                      >
                        <div>{casetail.date}</div>
                        {repairCase?.caseTail?.length > 2 &&
                          index === 0 && (
                            <button
                              onClick={() =>
                                setShowDetailStatus(!showDetailStatus)
                              }
                            >
                              {showDetailStatus
                                ? 'See less details'
                                : 'See more details'}
                            </button>
                          )}
                      </div>
                    ))}
                  </div>
                </div>
                <Rating
                  isRatingOpen={isRatingOpen}
                  setIsRatingOpen={setIsRatingOpen}
                  repairCase={repairCase}
                />
              </>
            )}
          </Container>
          {!quoteSummery?.isWithWarranty && (
            <div style={{ padding: '24px 0' }}>
              {(repairCase?.isDiagnosisPaymentDone ||
                repairCase?.isRepairPaymentDone) && (
                <>
                  <h4 style={{ textAlign: 'center' }}>
                    Payment Details
                  </h4>
                  <PaymentDetails quoteSummery={quoteSummery} />
                </>
              )}
            </div>
          )}
        </>
      );
      // if (repairCase?.caseStatus === 'collected') {
      //   quoteDetail = <>No Quote Available</>;
      // }
    } else {
      quoteDetail = (
        <>
          <CreateQuote
            isQuoteCreateOpen={quoteOpen}
            setIsQuoteCreateOpen={SetQuoteOpen}
            repairCase={repairCase}
            refreshRepairCase={() => {
              SetQuoteOpen(false);
            }}
            showDiagnosisQuote={false}
          />
          <div style={{ display: 'block', margin: '20px' }}>
            <ProductPicture
              pendingSrc={loading}
              productId={productDetails?.id}
              src={productImg(assignedProductDetails)}
              height={`${imgHeight}px`}
              css={{ margin: '0 auto' }}
            />
          </div>
          <div
            style={{
              display: 'flex',
              alignItems: 'stretch',
            }}
          >
            <div style={{ width: '48%', textAlign: 'center' }}>
              <DetailsTitle>Product Name</DetailsTitle>
              <DetailData>{productDetails?.name}</DetailData>
            </div>
            <div style={{ width: '2%' }}>
              <Divider
                orientation="vertical"
                flexItem
                style={{ height: '100%', width: '2px' }}
              />
            </div>
            <div style={{ width: '48%', textAlign: 'center' }}>
              <DetailsTitle>Issue Type</DetailsTitle>
              <DetailData>{issueType}</DetailData>
            </div>
          </div>
          <div>
            {!repairDetails && (
              <div
                style={{
                  boxShadow: '0px 3px 10px rgba(0,0,0, 0.161)',
                  borderRadius: '10px',
                  position: 'relative',
                  marginTop: '30px',
                }}
              >
                <div
                  style={{
                    position: 'absolute',
                    right: '0px',
                    boxShadow: '0px 3px 10px rgb(0 0 0 / 16%)',
                    borderRadius: '10px',
                    padding: '10px 20px',
                    color: '#31AD31',
                    top: '-20px',
                    background: '#fff',
                    zIndex: 1,
                  }}
                >
                  {!expandStatus && (
                    <div>
                      <button
                        onClick={() => {
                          setExpandStatus(true);
                        }}
                      >
                        Edit Status
                      </button>
                    </div>
                  )}
                  {expandStatus && (
                    <div>
                      <button
                        style={{ color: '#f6645b' }}
                        onClick={() => setExpandStatus(false)}
                      >
                        <Icon icon={IconLib.CROSS_BOXED} />
                      </button>
                    </div>
                  )}
                </div>
                <div
                // style={{
                //   opacity: expandStatus ? '1' : '0.4',
                // }}
                >
                  <Stepper
                    activeStep={activeStep}
                    orientation="vertical"
                    connector={<ColorlibConnectorVertical />}
                  >
                    {steps.map((label, index) => (
                      <Step
                        key={caseStatus[index]}
                        onClick={() =>
                          updateStatusCall(caseStatus[index])
                        }
                        style={{
                          opacity:
                            expandStatus || activeStep + 1 > index
                              ? '1'
                              : '0.4',
                        }}
                      >
                        <StepLabel
                          StepIconComponent={(e: StepIconProps) =>
                            ColorlibStepIcon(e)
                          }
                        >
                          {label}
                        </StepLabel>
                      </Step>
                    ))}
                  </Stepper>
                </div>
                <div
                  style={{
                    flexGrow: 1,
                    // height: 300,
                    gap: 10,
                    // display: 'flex',
                    display: 'none',
                    padding: 10,
                  }}
                >
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      flexDirection: 'column',
                      flex: 2,
                      textAlign: 'right',
                      fontSize: '10px',
                    }}
                  >
                    {repairCase?.caseTail?.map((casetail, index) => (
                      <div
                        key={casetail.date}
                        style={
                          index === 0 ||
                          index ===
                            repairCase?.caseTail?.length - 1 ||
                          showDetailStatus === true
                            ? index !== 0 &&
                              index !==
                                repairCase?.caseTail?.length - 1
                              ? {
                                  color: '#A8A8A8',
                                  marginBottom: '5px',
                                }
                              : {}
                            : { display: 'none' }
                        }
                      >
                        <div>
                          {StatusTypeMap.get(casetail.status)}
                        </div>
                        {repairCase?.caseTail?.length > 2 &&
                          index === 0 && <br />}
                      </div>
                    ))}
                  </div>
                  <BorderLinearProgress
                    variant="determinate"
                    value={currentStatus === 'collected' ? 0 : 10}
                    style={{ flex: 0.05 }}
                  />
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      flexDirection: 'column',
                      flex: 2,
                      textAlign: 'left',
                      fontSize: '10px',
                    }}
                  >
                    {repairCase?.caseTail?.map((casetail, index) => (
                      <div
                        key={casetail.date}
                        style={
                          index === 0 ||
                          index ===
                            repairCase?.caseTail?.length - 1 ||
                          showDetailStatus === true
                            ? index !== 0 &&
                              index !==
                                repairCase?.caseTail?.length - 1
                              ? {
                                  color: '#A8A8A8',
                                  marginBottom: '5px',
                                }
                              : {}
                            : { display: 'none' }
                        }
                      >
                        <div>{casetail.date}</div>
                        {repairCase?.caseTail?.length > 2 &&
                          index === 0 && (
                            <button
                              onClick={() =>
                                setShowDetailStatus(!showDetailStatus)
                              }
                            >
                              {showDetailStatus
                                ? 'See less details'
                                : 'See more details'}
                            </button>
                          )}
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            )}
            <ProductCommments
              tabTitle={
                currentStatus === caseStatus[4]
                  ? 'Add  Diagnosis Comments'
                  : 'Add Repair Comments'
              }
              isCommentDrawerOpen={isCommentDrawerOpen}
              SetIsCommentDrawerOpen={SetIsCommentDrawerOpen}
              repairCase={repairCase}
              SetIsQuoteOpen={SetIsQuoteOpen}
              loadRepairCaseApi={loadRepairCaseApi}
            />
            <div style={{ display: 'none' }}>
              <h4 style={{ textAlign: 'center' }}>Quote Details</h4>
              <PaymentDetails quoteSummery={quoteSummery} />
            </div>
            {/* <Button
              variant="outlined"
              size="medium"
              style={{ margin: '10px 0', width: '100%' }}
              onClick={() => onClickChat()}
            >
              Go to Chat
            </Button> */}
            <Button
              variant="text"
              style={{
                margin: '10px 0',
                width: '100%',
                color: '#31AD31',
              }}
              onClick={() => {
                setRepairDetails(!repairDetails);
              }}
            >
              Repair Details
            </Button>
            {/* <Button
              variant="text"
              style={{
                margin: '0',
                width: '100%',
                padding: '0',
                minHeight: '0',
              }}
              onClick={() => {
                setRepairDetails(!repairDetails);
              }}
            >
              {repairDetails ? (
                <Icon icon={IconLib.ARROW_HEAD_UP} />
              ) : (
                <Icon icon={IconLib.ARROW_HEAD_DOWN} />
              )}
            </Button> */}
            {/* {repairDetails && (
              <>
                <List>
                  {repairerCasePaymentDetail &&
                    repairerCasePaymentDetail[0]?.diagnosisQuote &&
                    repairerCasePaymentDetail[0]?.diagnosisQuote?.map(
                      item => (
                        <>
                          <ListItem>
                            <CustomListItemTextName primary="Diagnosis" />
                            <CustomListItemText
                              primary={`${
                                item.quotationAmount.amount ?? 0
                              } £`}
                              style={{ textAlign: 'right' }}
                            />
                          </ListItem>
                          <Divider />
                        </>
                      )
                    )}
                  {repairerCasePaymentDetail &&
                    repairerCasePaymentDetail[0]?.repairQuote &&
                    repairerCasePaymentDetail[0]?.repairQuote.map(
                      (rdq: RepairQuoteDetails) =>
                        rdq.quoteDetails ? (
                          rdq.quoteDetails.map((qd: QuoteDetails) => (
                            <>
                              <ListItem>
                                <CustomListItemTextName
                                  primary={qd.description}
                                />
                                <CustomListItemText
                                  primary={qd.qty}
                                  style={{ textAlign: 'center' }}
                                />
                                {qd.qty > 1 && (
                                  <CustomListItemText
                                    primary={qd.total}
                                    style={{
                                      color: '#a8a8a8',
                                      textAlign: 'center',
                                    }}
                                  />
                                )}
                                <CustomListItemText
                                  primary={`${(
                                    qd.qty * qd.total
                                  ).toFixed(2)} £`}
                                  style={{ textAlign: 'right' }}
                                />
                              </ListItem>
                              <Divider />
                            </>
                          ))
                        ) : (
                          <>
                            <ListItem>
                              <CustomListItemTextName primary="Repair Quote" />
                              <CustomListItemText
                                primary="1"
                                style={{ textAlign: 'right' }}
                              />
                              <CustomListItemText
                                primary={`${
                                  rdq.quotationAmount.amount ?? 0
                                } £`}
                                style={{ textAlign: 'right' }}
                              />
                            </ListItem>
                            <Divider />
                          </>
                        )
                    )}

                  <>
                    <ListItem>
                      <CustomListItemTextName primary="Subtotal" />
                      <CustomListItemText
                        primary={
                          repairerCasePaymentDetail &&
                          `${
                            repairerCasePaymentDetail[0]?.subtotal ??
                            0
                          } £`
                        }
                        style={{ textAlign: 'right' }}
                      />
                    </ListItem>
                    <Divider />
                  </>
                  <>
                    <ListItem>
                      <CustomListItemTextName primary="Service fee" />
                      <CustomListItemText
                        primary={
                          repairerCasePaymentDetail &&
                          `${
                            repairerCasePaymentDetail[0]
                              ?.applicationFee ?? 0
                          } £`
                        }
                        style={{ textAlign: 'right' }}
                      />
                    </ListItem>
                    <Divider />
                  </>
                  <>
                    <ListItem>
                      <CustomListItemTextName
                        style={{ color: '#31AD31' }}
                        primary="Total"
                      />
                      <CustomListItemText
                        primary={
                          repairerCasePaymentDetail &&
                          `${
                            repairerCasePaymentDetail[0]?.total ?? 0
                          } £`
                        }
                        style={{ textAlign: 'right' }}
                      />
                    </ListItem>
                    <Divider />
                  </>
                </List>
              </>
            )} */}
            {repairDetails && (
              <>
                <Table>
                  <thead>
                    <tr>
                      <th>Description</th>
                      <th>Qty</th>
                      <th>Price</th>
                    </tr>
                  </thead>
                  <tbody>
                    {repairerCasePaymentDetail &&
                      repairerCasePaymentDetail[0]?.diagnosisQuote &&
                      repairerCasePaymentDetail[0]?.diagnosisQuote?.map(
                        (item, index) => (
                          <tr key={`diagnosis${index + 1}`}>
                            <td>Diagnosis Quote</td>
                            <td />
                            <td>£{item.quotationAmount.amount}</td>
                          </tr>
                        )
                      )}
                    {repairerCasePaymentDetail &&
                      repairerCasePaymentDetail[0]?.repairQuote &&
                      repairerCasePaymentDetail[0]?.repairQuote.map(
                        (rdq: RepairQuoteDetails, rdqIndex) =>
                          rdq.quoteDetails ? (
                            rdq.quoteDetails.map(
                              (qd: QuoteDetails, dqIndex) => (
                                <tr key={`repair${dqIndex + 1}`}>
                                  <td>{qd.description}</td>
                                  <td>{qd.qty}</td>
                                  <td>
                                    {qd.qty > 1 && (
                                      <span
                                        style={{
                                          color: '#a8a8a8',
                                          float: 'left',
                                        }}
                                      >
                                        (£{qd.total})
                                      </span>
                                    )}
                                    <span
                                      style={{ color: '#000000' }}
                                    >
                                      £
                                      {(qd.qty * qd.total).toFixed(2)}
                                    </span>
                                  </td>
                                </tr>
                              )
                            )
                          ) : (
                            <tr key={`repair${rdqIndex + 1}`}>
                              <td>Repair Quote</td>
                              <td>1</td>
                              <td>£{rdq.quotationAmount.amount}</td>
                            </tr>
                          )
                      )}
                    <tr key="subTotal">
                      <td>Subtotal</td>
                      <td />
                      <td>
                        £
                        {repairerCasePaymentDetail &&
                          (repairerCasePaymentDetail[0]?.subtotal ??
                            0)}
                      </td>
                    </tr>
                    <tr key="serviceFee">
                      <td>Service fee</td>
                      <td />
                      <td>
                        {' '}
                        £
                        {repairerCasePaymentDetail &&
                          (repairerCasePaymentDetail[0]
                            ?.applicationFee ??
                            0)}
                      </td>
                    </tr>

                    <tr key="total">
                      <td>Total</td>
                      <td />
                      <td>
                        £
                        {repairerCasePaymentDetail &&
                          (repairerCasePaymentDetail[0]?.total ?? 0)}
                      </td>
                    </tr>
                  </tbody>
                </Table>
              </>
            )}
          </div>
        </>
      );
    }
  }
  return (
    <>
      {quoteSummery ? (
        <div
          style={{ display: 'block', margin: '20px', width: '100%' }}
        >
          <LoadingOverlay
            loadingComplete={!sending || loading}
            translucent
            color="primary"
          />
          {quoteDetail}
        </div>
      ) : (
        <>No Quote Available</>
      )}
    </>
  );
}
